module.exports = __webpack_public_path__ + "img/book_cover_last.f0eb0835.png";